import React from "react";
import SubjectHeader from "./SubjectHeader";
import VisitOverview from "./VisitOverview";
import NoRegistrationMessage from "./NoRegistrationMessage";
import './VisitOverview.css'
import { useSubject } from "../context/SubjectContext";
const ModerationVisitPanel = ({
  isRegistered,
  selectedSubject,
  selectedSubjectCode,
}) => {
  const { loading } = useSubject();
  if (loading) {
    return (
      <div className="loader-wrapper">
        <div className="spinner"></div>
        <p>Loading visit details...</p>
      </div>
    );
  }
  
  return (
    <>
      <SubjectHeader
        selectedSubject={selectedSubject}
        selectedSubjectCode={selectedSubjectCode}
      />
      {/* <div className="main-content-below-header"> */}
      {isRegistered === false && <NoRegistrationMessage />}
      {isRegistered === true && <VisitOverview />}
      {/* </div> */}
    </>
  );
};

export default ModerationVisitPanel;
